<template>
  <div class="ma-3">
    <div class="title mb-3">
      Sessions <v-icon>mdi-chevron-right</v-icon> Seasons management
    </div>

    <div
      layout="column"
      layout-align="center center"
    >
      <div
        layout="column"
        class="field-width"
      >
        <div
          layout="row"
          layout-align="start center"
          class="ml-3"
        >
          <v-select
            v-model="filters.team_id"
            v-focus
            solo
            single-line
            hide-details
            label="Team"
            :items="teams"
            item-text="name"
            item-value="id"
            class="mr-2"
            @change="fetch"
          />
          <v-select
            v-model="filters.topic_id"
            v-focus
            solo
            single-line
            hide-details
            label="Concept"
            :items="topics"
            item-text="name"
            item-value="id"
            class="mr-2"
            @change="fetch"
          />
          <v-btn
            depressed
            color="primary"
            @click="fetch"
          >
            Filter
          </v-btn>
          or
          <a
            href="#"
            class="ml-2 black--text"
            @click="resetFilters"
          >Cancel</a>
        </div>

        <div>
          <v-btn
            flat
            class="mt-3"
            :to="{name: 'admin-sessions-seasons-edit', params: {id: 'new'}}"
          >
            <v-icon
              left
              color="primary"
            >
              mdi-plus-box
            </v-icon>
            Add a new season
          </v-btn>
        </div>

        <v-data-table
          :headers="headers"
          :items="seasons"
          style="max-width: 1000px"
          :pagination.sync="pagination"
        >
          <template
            slot="items"
            slot-scope="{ item }"
          >
            <td>
              <v-icon
                :color="item.is_enabled ? 'success' : 'error'"
                :title="item.is_enabled ? 'Enabled' : 'Disabled'"
              >
                {{ item.is_enabled ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
              </v-icon>
            </td>
            <td>{{ item.team.name }}</td>
            <td>{{ item.topic.name }}</td>
            <td>{{ formatDate(item.start) }}</td>
            <td>{{ formatDate(item.end) }}</td>
            <td layout="row">
              <v-btn
                class="mx-0"
                icon
                :to="{name: 'admin-sessions-seasons-edit', params: {id: item.id}}"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>

              <v-btn
                :title="item.is_enabled ? 'Disable': 'Enable'"
                class="mx-0"
                icon
                @click="toggle(item)"
              >
                <v-icon>{{ item.is_enabled ? 'mdi-lock': 'mdi-lock-open' }}</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>

<script>
    import Params from '@/api/params'
    import Consts from '@/consts'
    import DateMixin from '@/mixins/date'

    export default {
        mixins: [DateMixin],
        data () {
            return {
                pagination: {
                    rowsPerPage: 10
                },
                headers: [
                    { text: 'Status', value: 'is_enabled', sortable: false, width: 75 },
                    { text: 'Team', value: 'team.name' },
                    { text: 'Concept', value: 'topic.name' },
                    { text: 'Start', value: 'start' },
                    { text: 'End', value: 'end' },
                    { text: 'Actions', sortable: false, width: "80px" }
                ],
                filters: {
                    team_id: null,
                    topic_id: null
                },
                seasons: [],
                teams: [],
                topics: []
            }
        },
        mounted () {
            this.fetch();
            this.fetchParams()
        },
        methods: {
            fetch () {
                Params.getList('seasons', this.filters).then(res => {
                    this.seasons = res.data;
                })
            },
            fetchParams(){
                Params.getList('teams', {is_enabled: 1}).then(res => {
                    this.teams = res.data
                })
                Params.getList('topics', {is_enabled: 1, application: Consts.APPLICATION.FREELANCES}).then(res => {
                    this.topics = res.data
                })
            },

            resetFilters () {
                this.filters = {team_id: null, topic_id: null};
                this.fetch();
            },

            toggle (item) {
                if (item.is_enabled) {
                    Params.disable('seasons', item.id).then(() => {
                        this.fetch();
                        this.$snotify.success(`Season has been disabled`)
                    })
                } else {
                    Params.enable('seasons', item.id).then(() => {
                        this.fetch();
                        this.$snotify.success(`Season has been enabled`)
                    })
                }
            }
        }
    }
</script>
